import React, {useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory, useLocation} from 'react-router';
import {useErrorModal, useModalControls} from 'utils/hooks';
import {StripeError} from '@stripe/stripe-js';
import {useReservation} from '../../context/reservation';
import {useCartDeals} from '../../hooks';
import {PATHS} from 'Routes';
import {PaymentForm, PaymentFormRefType} from 'components/PaymentForm/PaymentForm';
import {PaymentTypes} from 'hooks/usePayment';
import successImg from 'assets/img/status-success-icon.png';
import PaidModal from '../PaidModal';
import Summary from './components/Summary';
import {Content} from './styled';

const PaymentsDetailsForm = React.memo(() => {
  const {t} = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const {data: reservation} = useReservation();
  const {ErrorModal, displayError} = useErrorModal();
  const paymentFormRef = useRef<PaymentFormRefType>(null);
  const [totalAmounPaid, setTotalAmountPaid] = React.useState<string>('');
  const [isDisabledSubmit, setIsDisabledSubmit] = React.useState(false);
  const {clearCartDeals} = useCartDeals({onError: displayError});
  const {
    isOpen: isPaidModalOpen,
    openModal: openPaidModal,
    closeModal: closePaidModal,
  } = useModalControls(false);

  const onSubmit = () => {
    setTotalAmountPaid(reservation.total_amount_to_pay || '');
    paymentFormRef?.current?.submit();
  };

  const onPaymentError = (error?: StripeError) => {
    displayError(error);
  };

  const handlePaidModal = React.useCallback(() => {
    closePaidModal();
    history.push(PATHS.finish, location.state);
  }, [closePaidModal, history, location.state]);

  const handleSuccess = React.useCallback(() => {
    clearCartDeals();
    openPaidModal();
  }, [clearCartDeals, openPaidModal]);

  return (
    <>
      <Content>
        <PaymentForm
          className="paymentForm"
          paymentType={PaymentTypes.guest}
          onPaymentError={onPaymentError}
          onPaymentSuccess={handleSuccess}
          setIsDisabledSubmit={setIsDisabledSubmit}
          ref={paymentFormRef}
          withoutSubmitButton
        />
        {/*------------Future Feature-----------*/}
        {/*<InvoicingDetails className="invoicingDetails" />*/}
        {/*------------Future Feature-----------*/}
        {/* <MessageHost /> */}
        <Summary className="summary" disabled={isDisabledSubmit} onSubmit={onSubmit} />
      </Content>
      <PaidModal
        isPaymentMethod
        totalPice={totalAmounPaid}
        subTitle={t('you_payment_has_been_made_successfully')}
        imageSrc={successImg}
        isOpenPaidModal={isPaidModalOpen}
        handlePaidModal={handlePaidModal}
      />
      <ErrorModal />
    </>
  );
});

export {PaymentsDetailsForm};
